import Vue from 'vue'
import Router from 'vue-router'

import Users from '@/components/pages/Users'
import Records from '@/components/pages/Records'
import Checklists from '@/components/pages/Checklists'
import Species from '@/components/pages/Species'
import Taxonomy from '@/components/pages/Taxonomy'
import Account from '@/components/pages/Account'
import Profile from '@/components/pages/Profile'
import MyProfile from '@/components/pages/MyProfile'
import MySpecies from '@/components/pages/MySpecies'
import MyLocations from '@/components/pages/MyLocations'
import Maps from '@/components/pages/Maps'
import ChecklistAdd from '@/components/pages/ChecklistAdd'
import ChecklistEdit from '@/components/pages/ChecklistEdit'
import ChecklistView from '@/components/pages/ChecklistView'
import RecoverPasswordView from '@/components/pages/RecoverPasswordView' 
import ConfirmAccountView from '@/components/pages/ConfirmAccount' 
import ProjectsView from '@/components/pages/Projects' 
import TaxonomyList from '@/components/pages/TaxonomyList' 
import AccountPhotos from '@/components/pages/AccountPhotos' 
import BulkUpload from '@/components/pages/BulkUpload' 
import BulkUploadReview from '@/components/pages/BulkUploadReview'
import BulkUploadImports from '@/components/pages/BulkUploadImports'

Vue.use(Router)

export default new Router({
	base: "/app/",
	mode: "hash",
  	routes: [
		{ 
			path: '/users/',
			name: 'users',
			component: Users,
			meta:{
				title:'Odonata Central User Directory'
			}
		},
		{ 
			path: '/data/records/*',
			name: 'records',
			component: Records,
			meta:{
				title:'Sighting Records'
			}
		},
		{ 
			path: '/data/checklists/*',
			name: 'checklists',
			component: Checklists,
			meta:{
				title:'Checklists'
			}
		},
		{ 
			path: '/data/species/*',
			name: 'species',
			component: Species,
			meta:{
				title:'Odonata Species'
			}
		},
		{ 
			path:'/taxonomy/',
			name: 'taxonomy',
			component: Taxonomy,
			meta:{
				title:'Dragonfly and Damselfly Identification & Taxonomy'
			}
		},
		{ 
			path:'/account/',
			name: 'account',
			component: Account,
			meta:{
				title:'My Account'
			}
		},
		{ 
			path:'/account/photos/',
			name: 'account-photos',
			component: AccountPhotos,
			meta:{
				title:'Add Checklist Photos'
			}
		},
		{ 
			path:'/data/batchupload/',
			name: 'batchupload',
			component: BulkUpload,
			meta:{
				title:'Bulk Upload Observations'
			}
		},
		{ 
			path:'/data/batchupload/review/',
			name: 'batchuploadreview',
			component: BulkUploadReview,
			meta:{
				title:'Review Bulk Uploads'
			}
		},
		{ 
			path:'/data/batchupload/imports/',
			name: 'batchuploadimports',
			component: BulkUploadImports,
			meta:{
				title:'Bulk Upload Imports'
			}
		},
		{ 
			path:'/profile/:id/',
			name: 'profile',
			component: Profile,
			meta:{
				title:'Profile'
			}
		},
		{ 
			path:'/my-profile/',
			name: 'my-profile',
			component: MyProfile,
			meta:{
				title:'Redirecting to Your Profile'
			}
		},
		{ 
			path:'/my-species/',
			name: 'my-species',
			component: MySpecies,
			meta:{
				title:'Redirecting to Your Species'
			}
		},
		{ 
			path:'/my-locations/',
			name: 'my-locations',
			component: MyLocations,
			meta:{
				title:'My Locations'
			}
		},
		{ 
			path:'/maps/',
			name: 'maps',
			component: Maps,
			meta:{
				title:'Odonata Maps'
			}
		},
		{ 
			path:'/add/',
			name: 'checklist_add',
			component: ChecklistAdd,
			meta:{
				title:'Submit Checklist'
			}
		},
		{ 
			path:'/edit/:id/',
			name: 'checklist_edit',
			component: ChecklistEdit,
			meta:{
				title:'Edit Your Checklist'
			}
		},
		{ 
			path:'/view/:id/',
			name: 'checklist_view',
			component: ChecklistView,
			meta:{
				title:'Viewing Checklist'
			}
		},
		{ 
			// /password/reset/confirm/OTYyOAa/5dz-cee4bcf00fa7749145bea
			path:'/password/reset/confirm/:uid/:token/',
			name: 'recover_password',
			component: RecoverPasswordView,
			meta:{
				title:'Reset Your Password'
			}
		},
		{ 
			path:'/activate/:uid/:token/',
			name: 'confirm_account',
			component: ConfirmAccountView,
			meta:{
				title:'Confirm Your Account'
			}
		},
		{ 
			path:'/projects/',
			name: 'projects',
			component: ProjectsView,
			meta:{
				title:'Projects'
			}
		},
		{ 
			path:'/wol/',
			name: 'taxonomy_list',
			component: TaxonomyList,
			meta:{
				title:'World Odonata List'
			}
		},

	]
})



// WEBPACK FOOTER //
// ./src/router/index.js